import moment from 'moment';

import { tickets } from '../types';


const INITIAL_STATE = {
    error: undefined,
    alreadyAcceptedTickets: [],
    activeTab: 'new',
    selectedProject: { value: localStorage.getItem('selectedProject') ? parseInt(localStorage.getItem('selectedProject')) : 'all', name: 'All Projects' },
    selectedCustomer: { value: localStorage.getItem('selectedCustomer') ? parseInt(localStorage.getItem('selectedCustomer')) : 'all', name: 'All Customers' },
    selectedTicketOwner: { value: 'both', name: 'Both' },
    search: false,
    filteredList: [],
    limit: 10,
    page: 1,
    activeSiteIndex: -1,
    selectedTickets: {},
    selectAll: 0,
    lastScannedIndex: 0,
    sortedBy: 'created_at'
}

const ticketsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case tickets.CREATE_INDEPENDENT_TICKETS_SUCCESS:
            return {
                ...state,
                ticketCreated: action.payload
            }

        case tickets.VIEW_TICKET_SUCCESS:
            return {
                ...state,
                viewTicket: action.payload
            }

        case tickets.RESET_TICKETS_STORE_SUCCESS:
            return INITIAL_STATE

        // Error
        case tickets.VIEW_TICKET_FAILURE:
            return { ...state, viewTicket: undefined, error: action.payload }

        case tickets.TICKETS_LIST_SUCCESS:
            return {
                ...state,
                tickets: action.payload && Array.isArray(action.payload) ? action.payload.map(ticket => {
                    let execution_date = ticket.execution_date;
                    if (execution_date && !execution_date.includes('0000-00-00')) {
                        execution_date = moment(execution_date).subtract(5.5, 'hours').toISOString();
                    }
                    let ticket_status = setStatus(ticket?.ticket_status)
                    return { ...ticket, execution_date , ticket_status};
                })
                    : action.payload
            }

        case tickets.TICKETS_COUNT_SUCCESS:
            return { ...state, ticketsCount: action.payload }


        case tickets.CREATE_INDEPENDENT_TICKETS_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return {
                ...state
            }
    }
}

export default ticketsreducer


const setStatus = (status) => {
    if (status === "FE accepted the ticket but Execution not started" || status === "FE assigned but not accepted" || status === "FE Auto accepted the ticket but Execution not started" || status === "FE Reached Site and Execution started" || status === "NOC is assigned " || status === "NOC updated the ticket " || status === "Sign off Rejected" || status === "SP accepted the ticket but FE Unassignd" || status === "SP accepted the ticket but FE Unassigned" || status === "Ticket Broadcasted" || status === "Ticket Resumed" || status === "Ticket Revisit Approved"){
        return { status : "In Progress" , style : "border border-scogoOrange text-scogoOrange"}
    } else if ( status === "Sign off accepted" || status === "Sign off Accepted by customer pending with Scogo" || status === "Sign off Auto Accepted" || status === "Sign off Auto Accepted by customer pending with Scogo" || status === "Sign off recieved" ){
        return { status : "Sign Off" , style : "border border-success text-success"}
    } else if ( status === "ticket closed" || status === "Ticket Closed Forcefully"){
        return { status : "Closed" , style : "border border-grey text-grey"}
    } else if (status === "Ticket Is on hold"){
        return { status : "On Hold" , style : "border border-scogoRed text-scogoRed"}
    } else if (status === "Ticket Created"){
        return { status : "New" , style : "border border-darkblue text-darkblue"}
    } else return {}
}